import React, { Component } from "react";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";

class Convite extends Component {
  constructor (props) {
    super(props);
  }

  componentDidMount () {
    const {
      match,
      history,
      token
    } = this.props;

    if (token !== null) {
      this._updatePersonInviter();
    }

    if (window && window.location) {
      window.location = "https://sua.glambox.com.br/convite";
    }

    // history.push("/");
  }

  render () {
    return null;
  }

  // --------------------------------------------------------------------

  _updatePersonInviter = () => {
    const {
      match,
      token
    } = this.props;

    // TODO: UpdatePersonInviter /person/inviter
    ExecuteRequest(
      GlamboxEndpoints.Person.updatePersonInviter,
      {
        personInviterId: match.params.personInviterId
      },
      "PUT",
      {
        Authorization: token.Authorization
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          console.log("OK");
        }
      }
    );
  };
}

const mapStateToProps = (state) => ({
  token: state.token.data
});

const mapDispatchToProps = (dispatch) => ({
});

Convite = connect(mapStateToProps, mapDispatchToProps)(Convite);

export {
  Convite
};
